<template>
  <div>
    <div
      class="friend-link-container"
      :style="{
        backgroundImage: `url(${bgImgUrl || noUpload})`,
        'background-color': configDataForm.backGroundColor,
        color: configDataForm.fontColor,
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
        'background-position': 'center',
        '--footer-font-color': configDataForm.fontColor,
      }"
      @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
      @mouseleave="handleShowOperationBtn(false)"
    >
      <div class="link-container">
        <div class="title">
          <div
            class="title-icon"
            :style="{
              'background-image': `url(${iconFileFullUrl || noUpload})`,
              'background-size': 'contain',
              'background-repeat': 'no-repeat',
              'background-position': 'center',
            }"
          ></div>
          <div
            class="title-text"
            :style="{
              color: configDataForm.fontColor,
            }"
          >
            {{ configDataForm.title }}
          </div>
        </div>
        <div class="content">
          <a
            v-for="item in configDataForm.items"
            :key="item.siteId"
            :href="item.siteUrl"
            :style="{
              color: configDataForm.fontColor,
            }"
            class="link"
            target="_blank"
            rel="noopener noreferrer"
            >{{ item.siteName }}</a
          >
        </div>
      </div>

      <operation-container
        v-if="showOperationBtn && !showEditForm"
        :component-data="props.componentData"
        :show-edit-content-button="props.showEditContentButton"
        :show-edit-components-button="props.showEditComponentsButton"
        :show-delete-components-button="props.showDeleteComponentsButton"
        :show-insert-components-button="props.showInsertComponentsButton"
        :show-sort-components-button="props.showSortComponentsButton"
        @handle-show-edit-form="handleShowEditForm"
        @handle-change-components="handleChangeComponents"
        @handle-delete-components="handleDeleteComponents"
        @handle-insert-components="handleInsertComponents"
        @handle-sort-components="handleSortComponents"
      ></operation-container>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <friend-link-edit-form
        v-if="showEditForm"
        v-model="configDataForm"
        :component-data="props.componentData"
        @handle-edit-components-content="handleEditComponentsContent"
        @handle-show-edit-form="handleShowEditForm"
      ></friend-link-edit-form>
    </el-drawer>
  </div>
</template>
<script setup>
// #region 引用
import OperationContainer from '../common/OperationContainer.vue';
import FriendLinkEditForm from './FriendLinkEditFormFour.vue';
// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});
// console.log('props-configDataForm-FriendLinkThree:', props);

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量

// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
  query: '?url',
});
// 直接获取目标图片 URL
const noUpload =
  images['/src/assets/images/web/common/other/no-upload.png']?.default;

const configDataForm = ref({
  backGroundImageFullUrl: null,
  backGroundColor: null,
  fontColor: null,
});

// 表单绑定对象

if (props.componentData.configData) {
  configDataForm.value = JSON.parse(props.componentData.configData);
  configDataForm.value.items.sort((a, b) => {
    return a.sortNum - b.sortNum;
  });
}

// 背景图/图标
const iconFileFullUrl = computed(() => {
  return configDataForm.value ? configDataForm.value.iconFullUrl : '';
});
const bgImgUrl = computed(() => {
  return configDataForm.value
    ? configDataForm.value.backGroundImageFullUrl
    : '';
});
// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};
/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};
/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // console.log('configDataForm-FriendLinkThree--1:', configDataForm);
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataForm.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};

// #endregion
</script>
<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

/* PC端样式 */
@include pc {
  .friend-link-container {
    position: relative;
    display: flex;
    justify-content: center;
    height: 80px;
    padding-right: 30px;
    padding-left: 30px;
    .link-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      border-bottom: 1px solid #cfd0c5;
      .title {
        display: flex;
        flex-shrink: 0;
        flex-direction: row;
        align-items: center;
        width: auto;
        height: 100%;
        font-size: 24px;
        font-weight: 700;
        .title-icon {
          width: 24px;
          height: 24px;
          margin-right: 2px;
          object-fit: contain;
        }

        .title-text {
          white-space: nowrap;
        }
        .title-text::after {
          margin-left: 2px;
          font-size: 24px;
          content: ':';
        }
      }
      .content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        font-size: 22px;
        .link {
          position: relative;
          margin: 0 20px;
          transition: color 250ms ease;
        }
        .link:first-of-type {
          margin-left: 20px;
        }

        .link:not(:first-of-type)::before {
          position: absolute;
          top: -2px;
          left: -20px;
          height: 100%;
          font-size: 22px;
          content: '|';
        }

        .link:hover {
          color: #00b4d8;
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

/* 移动端样式 */
@include mobile {
  .friend-link-container {
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;
    height: auto;
    padding: 4vw 3vw;
    .link-container {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: auto;
      .title {
        display: flex;
        flex-shrink: 0;
        flex-direction: row;
        align-items: center;
        width: auto;
        height: auto;
        font-size: 4.5vw;
        font-weight: 700;
        .title-icon {
          width: 5vw;
          height: 5vw;
          margin-right: 2vw;
          object-fit: contain;
        }

        .title-text {
          white-space: nowrap;
        }
        .title-text::after {
          margin-left: 2px;
          font-size: 4.5vw;
          content: ':';
        }
      }
      .content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        font-size: 4vw;
        .link {
          position: relative;
          margin: 1.5vw;
        }
        .link:first-of-type {
          margin-left: 0;
        }

        .link:active {
          color: #00b4d8;
        }
      }
    }
  }
}
</style>
